module.exports = __webpack_public_path__ + "img/logo-branca.e966e335.svg";